import { LOG_IN } from '../constants';

export const logIn = (token) => ({
  type: LOG_IN,
  token,
});
